import { type CSSProperties, type ReactNode, forwardRef } from 'react'
import PlentyBody from '#app/components/typography/plenty-body'
import { Button } from '#app/components/ui/button'
import { Icon } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'

interface FilterButtonProps {
	children?: ReactNode
	style?: CSSProperties // Add style prop
	isSelectorOpen?: boolean // Change this to string
}

const SortButton = forwardRef<
	HTMLButtonElement,
	FilterButtonProps & { sortText: string }
>(({ sortText, isSelectorOpen, ...props }, ref) => {
	return (
		<Button
			ref={ref}
			variant="filter_button"
			className={cn(
				'w-auto flex-shrink',
				' h-11 w-full gap-8 text-[18px] leading-[1-375rem] md:w-auto md:gap-4 md:text-[22px] md:leading-7',
			)}
			{...props}
		>
			<div className="flex w-full items-center justify-between gap-2 ">
				<PlentyBody size={'md'}>{sortText}</PlentyBody>
				<Icon
					name="chevron-down"
					size="md"
					className={`transition-transform duration-200 ease-in-out ${
						isSelectorOpen ? 'rotate-180' : 'rotate-0'
					}`}
				/>
			</div>
		</Button>
	)
})
SortButton.displayName = 'SortButton'
export { SortButton }
